import React from 'react';

export const styles = {
  value: {
    color: 'rgb(142 142 142)',
    fontWeight: 'normal',
  },
};

const TableRow = ({label, value, action, optional}) => {
  return (
    <tr>
      <th>{label}</th>
      <th style={styles.value}>{value}</th>
      <th>{action}</th>
      <th style={styles.value}>{optional}</th>
    </tr>
  );
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/pages/Support/components/TableRow/index.js